<template>
  <el-form :model="salary_form" :rules="rules" ref="salaryForm" label-width="0px" class="demo-info_form">
    <div style="display: flex;align-items: center;">
      <el-form-item label="" prop="min_value">
        <el-select :popper-append-to-body='false' v-model="salary_form.min_value" placeholder="最低" @change="changeMinPartValue">
          <el-option v-for="item in min_salary_option" :key="item" :label="(recruitment_type==1 || recruitment_type==2)?item+'k':item" :value="item">
          </el-option>
        </el-select></el-form-item>
      <el-form-item v-if="salary_form.min_value" label="" prop="max_value">
        <el-select :popper-append-to-body='false' v-model="salary_form.max_value" placeholder="最高" style="margin:0 15px;">
          <el-option v-for="item in max_salary_option" :key="item" :label="(recruitment_type==1 || recruitment_type==2)?item+'k':item" :value="item">
          </el-option>
        </el-select></el-form-item>
      <span style="margin-right: 15px;" v-if="salary_form.min_value">x</span>
      <el-form-item v-if="recruitment_type!=3 && salary_form.min_value" label="" prop="salary_unit">
        <el-select :popper-append-to-body='false' v-model="salary_form.salary_unit" placeholder="请选择">
          <el-option v-for="item in salary_unit_option" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <span v-if="recruitment_type==3 && salary_form.min_value">元/天</span>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "",
  props: [
    "recruitment_type",
    "salary_max",
    "salary_min",
    "salary_month",
    "salary_unit",
  ],
  data() {
    return {
      salary_form: {
        min_value: 200,
        max_value: 250,
        salary_unit: null,
      },
      monthly_value: "",
      monthly_option: [],
      min_salary_option: [],
      max_salary_option: [],
      salary_unit_option: [
        {
          label: "元/时",
          value: 1,
        },
        {
          label: "元/天",
          value: 2,
        },
        {
          label: "元/周",
          value: 3,
        },
        {
          label: "元/月",
          value: 4,
        },
      ],
      rules: {
        min_value: [
          { required: true, message: "请输入最低薪资", trigger: "change" },
        ],
        max_value: [
          { required: true, message: "请输入最高薪资", trigger: "change" },
        ],
        salary_unit: [
          { required: true, message: "请输入薪资单位", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    recruitment_type: {
      handler(newVal) {
        this.init();
      },
      deep: true,
      immediate: true,
    },
    salary_max: {
      handler(newVal) {
        this.init();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    init() {
      if (this.recruitment_type == 1 || this.recruitment_type == 2) {
        this.salary_form.min_value = this.salary_min
          ? Number(this.salary_min / 1000)
          : null;
        this.salary_form.max_value = this.salary_max
          ? Number(this.salary_max / 1000)
          : null;
        this.salary_form.salary_unit = this.salary_month
          ? this.salary_month
          : 12;
        this.min_salary_option = this.generateSequence();
        this.salary_unit_option = this.getSalaryMounth();
      } else if (this.recruitment_type == 3) {
        this.salary_form.min_value = this.salary_min ? this.salary_min : 200;
        this.salary_form.max_value = this.salary_max ? this.salary_max : 250;
        this.min_salary_option = this.generateMinSalary(10, 1000);
      } else {
        this.min_salary_option = this.generateMinSalary(10, 1000);
        this.salary_form.min_value = this.salary_min ? this.salary_min : null;
        this.salary_form.max_value = this.salary_max ? this.salary_max : null;
        this.salary_form.salary_unit = this.salary_unit ? this.salary_unit : 1;
      }
      if (this.salary_form.min_value) {
        this.changeMinPartValue();
      }
      this.$nextTick(() => {
        this.$refs.salaryForm.clearValidate();
      });
    },
    generateSequence() {
      const sequence = [];
      let current = 1;
      // 1到30，每次加1
      while (current <= 30) {
        sequence.push(current);
        current += 1;
      }
      // 30到100，每次加5（从35开始，避免重复30）
      current = 35;
      while (current <= 100) {
        sequence.push(current);
        current += 5;
      }
      // 100到250，每次加10（从110开始，避免重复100）
      current = 110;
      while (current <= 250) {
        sequence.push(current);
        current += 10;
      }

      return sequence;
    },
    getSalaryMounth() {
      let arr = [];
      for (let i = 12; i < 24; i++) {
        let obj = {
          label: i + "个月",
          value: i,
        };
        arr.push(obj);
      }
      return arr;
    },
    generateMinSalary(min, max) {
      const sequence = [];
      let current = min;
      // 1到30，每次加1
      while (current <= max) {
        sequence.push(current);
        current += 10;
      }
      return sequence;
    },
    changeMinValue() {
      this.salary_form.max_value = this.min_value + 50;
      this.max_salary_option = this.generateMinSalary(
        this.salary_form.min_value + 10,
        this.salary_form.min_value * 2
      );
    },
    changeMinPartValue() {
      if (this.recruitment_type == 1 || this.recruitment_type == 2) {
        let index = this.min_salary_option.findIndex(
          (item) => item == this.salary_form.min_value
        );
        if (index + 1 == this.min_salary_option.length) {
          this.max_salary_option = [];
        } else {
          this.max_salary_option = this.min_salary_option.slice(
            index + 1,
            index + 6
          );
        }
        if (this.max_salary_option.length < 5) {
          this.max_salary_option.push(
            this.min_salary_option[this.min_salary_option.length - 1] + 10
          );
        }
        this.salary_form.max_value = this.max_salary_option[0];
      }
      if (this.recruitment_type == 3 || this.recruitment_type == 4) {
        this.max_salary_option = this.generateMinSalary(
          this.salary_form.min_value + 10,
          this.salary_form.min_value + 60
        );
      }
    },
    checkSalary() {
      this.$refs.salaryForm.validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
::v-deep .el-select-dropdown__item.selected {
  color: #685ef5;
}
</style>
